module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/typography/multi-border-title/multi-border-title.component.scss
// module id = ./src/app/features/typography/multi-border-title/multi-border-title.component.scss
// module chunks = main